export default "__VITE_ASSET__95f554a5__"